import React, { useState } from 'react';
import { oneOf } from 'prop-types';
import { MOBILE } from '@thd-olt-functional/utils';
import { Drawer, DrawerItem, DrawerNav } from '@thd-olt-component-react/drawer';
import { HdppLearnmore } from '@thd-olt-component-react/hdpp-learnmore';
import { Button, Image } from '@thd-olt-component-react/core-ui';
import { buildImageURL } from '../../../utils/product-add-on-utils';
import { ICONS } from '../../../utils/product-add-on-constants';
import styles from './home-depot-protection-plan.module.scss';

const ProtectionPlanDrawer = ({
  channel
}) => {

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const isMobile = channel === MOBILE;
  const drawerMaxSize = isMobile ? 100 : 500;

  const openDrawer = (event) => {
    event.preventDefault();
    setIsDrawerOpen(true);
  };

  return (
    <div>
      <Button type="button" onClick={openDrawer} className={styles.hdpp__button} link>
        <span className="hdpp-tooltip-drawer__btn-content">Learn more</span>
        <Image
          height={1}
          width={1}
          title="information tooltip"
          lazy={false}
          src={buildImageURL(ICONS.info)}
          alt="information tooltip"
          className="product-add-on-tooltip-content__label__suffix"
        />
      </Button>
      {isDrawerOpen && (
        <Drawer
          open={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          initialItem="Protection Plan View"
          position="right"
          maxSize={drawerMaxSize}
          isMobile={isMobile}
        >
          <DrawerNav>
            <span className="product-add-ons-pod__content__main__title">Protect Your Purchase</span>
          </DrawerNav>
          <DrawerItem name="Protection Plan View">
            <HdppLearnmore />
          </DrawerItem>
        </Drawer>
      )}
    </div>
  );
};

ProtectionPlanDrawer.displayName = 'ProductAddOns-HdppDrawer';

ProtectionPlanDrawer.propTypes = {
  /** Device Type: Mobile or Desktop */
  channel: oneOf(['desktop', 'mobile'])
};

ProtectionPlanDrawer.defaultProps = {
  channel: 'desktop'
};

export { ProtectionPlanDrawer };